import { create } from 'zustand'

interface CustomerFormStore {
  isDirty: boolean
  setIsDirty: (isDirty: boolean) => void
  isSaving: boolean
  setIsSaving: (isSaving: boolean) => void
}

export const useCustomerFormStore = create<CustomerFormStore>((set) => ({
  isDirty: false,
  setIsDirty: (isDirty) => set({ isDirty }),
  isSaving: false,
  setIsSaving: (isSaving) => set({ isSaving }),
}))
